import React from "react";

/**
 * Kundennummer prominent (weclapp-Nummer groß), Altnummern klein darunter
 * ("Majesty 40174") - so vom Meeting für die Kundenrangliste je Vertreter
 * vorgegeben (plan.md AP6).
 */
export default function CustomerNumberCell({customerNumber, legacyNumbers}) {
    return (
        <div>
            <div className="fw-semibold">{customerNumber}</div>
            {Array.isArray(legacyNumbers) && legacyNumbers.length > 0 && (
                <div className="small text-muted">
                    {legacyNumbers.map((nr) => `Majesty ${nr}`).join(", ")}
                </div>
            )}
        </div>
    );
}
